import React from "react";
import { Route, Routes } from "react-router-dom";
import RsvpLayout from "components/layouts/rsvp-layout";
import RsvpHome from "containers/rsvp/rsvp-home";
import RsvpEditProfile from "containers/rsvp/edit-profile";
import RsvpExperiences from "containers/rsvp/experiences";
import RsvpExperiencesDetail from "containers/rsvp/experience-details";
import RsvpHostProfileDetail from "containers/rsvp/host-profile-details";
import RsvpGeneralSettings from "containers/rsvp/general-settings";
import Attendess from "containers/rsvp/experience-details/attendees";
import RsvpMyBadges from "containers/rsvp/my-badges";
import RsvpViewRatings from "containers/rsvp/experience-details/component/viewRatings";
import RsvpCommunities from "containers/rsvp/rsvp-communities";

const RsvpRoutes = () => {
  return (
    <RsvpLayout>
      <Routes>
        <Route path="/home" element={<RsvpHome />} />
        <Route path="/edit-profile" element={<RsvpEditProfile />} />
        <Route path="/experiences" element={<RsvpExperiences />} />
        <Route path="/experiences-detail" element={<RsvpExperiencesDetail />} />
        <Route path="/host-profile-detail" element={<RsvpHostProfileDetail />} />
        <Route path="/my-badges" element={<RsvpMyBadges />} />
        <Route path="/general-settings" element={<RsvpGeneralSettings />} />
        <Route path="/attendess" element={<Attendess/>} />
        <Route path="/view-ratings" element={<RsvpViewRatings />} />
        <Route path="/communities" element={<RsvpCommunities />} />
      </Routes>
    </RsvpLayout>
  );
};

export default RsvpRoutes;
